<template>
  <v-container
    class="d-flex flex-column fill-height justify-space-around"
    :class="{ 'scale-small': small }"
  >
    <!--
      This div is the only element within the `flex-column` layout
      of the parent `v-container`. It enables its children to be
      placed vertically in the middle of the container

      TODO: Restructure the layout to avoid requiring an unstyled div
    -->
    <div>
      <v-row class="mb-6 d-flex justify-space-around">
        <div
          class="d-flex flex-column justify-space-around bubble"
          :class="bubbleColor"
        >
          <slot name="bubble">
            <v-progress-circular
              v-if="loading"
              color="grey darken-2"
              class="loading"
              indeterminate
              :size="150"
              :width="10"
            />
            <v-icon
              v-else
              :color="iconColor"
              class="material-icons-outlined scale-4"
            >
              {{ icon }}
            </v-icon>
          </slot>
        </div>
      </v-row>
      <v-row class="mb-6 d-flex flex-column">
        <div class="mb-3 text-h5 text-center black--text">
          <slot name="prompt">{{ promptText }}</slot>
        </div>
        <div class="text-center message" :class="messageClass">
          <slot name="message"></slot>
        </div>
      </v-row>
      <v-row class="d-flex justify-space-around">
        <slot name="action"></slot>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'PageContentPlaceholder',
  props: {
    icon: {
      type: String,
      default: 'mouse',
    },
    promptText: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: 'grey lighten-1',
    },
    bubbleColor: {
      type: String,
      default: 'grey lighten-3',
    },
    messageClass: {
      type: String,
      default: 'grey--text text--darken-2',
    },
    small: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.bubble {
  width: 12rem;
  max-width: 12rem;
  height: 12rem;
  border-radius: 50%;
}

.message {
  font-size: 1.25rem;
  line-height: 175%;
}

.loading {
  margin: auto;
}

.scale-4 {
  transform: scale(4);
}
.scale-small {
  transform: scale(0.65);
}
</style>
